import React from 'react';
import styled from 'styled-components';

import { EmptyState, EmptyText } from 'components/customer/answer_panel/lib/empty_state';
import BookMagnifyingGlassIcon from 'components/lib/icons/book_magnifying_glass_icon';

export default function EmptyAnswerSearch() {
  return (
    <Empty data-aid="emptyAnswerSearch">
      <BookMagnifyingGlassIcon />
      <EmptyText>No results</EmptyText>
    </Empty>
  );
}

const Empty = styled(EmptyState)`
  .bookMagnifyingGlassIcon {
    height: 60px;
    width: 60px;
  }
  .bookMagnifyingGlassIcon-circle {
    fill: ${p => p.theme.colors.gray100};
  }
  .bookMagnifyingGlassIcon-stroke {
    stroke: ${p => p.theme.colors.green400};
  }
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/search/empty_answer_search.jsx